import Grid from "@mui/material/Grid";
import { MaterialReactTable } from 'material-react-table';
import { createTheme, ThemeProvider, useTheme } from '@mui/material';
import isURL from 'validator/lib/isURL';
import React, { useEffect, useState, useMemo, useRef } from 'react';
import MDBox from "components/MDBox";
import { Card } from "@material-ui/core";
import MDTypography from "components/MDTypography";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useParams } from 'react-router-dom';
import configurations from "config";
import { handleErrors, convertToBase64, manipulateDataForDefaultSelected, processCustomFields, convertToTree, handleSkuExist } from "common.js";
import { useTranslation } from "react-i18next";
import { useMaterialUIController } from "context";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MenuItem from '@mui/material/MenuItem';
import CircularProgress from "@mui/material/CircularProgress";
import { InputAdornment } from "@mui/material";
import Icon from "@mui/material/Icon";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import { Box, IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { DropzoneAreaBase } from 'material-ui-dropzone';
import TreeSelect from "components/TreeSelect";
import Backdrop from '@mui/material/Backdrop';
import { Radio, RadioGroup, FormControlLabel } from "@mui/material";
import "react-image-gallery/styles/css/image-gallery.css";
import { Country } from 'country-state-city';
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout/index.js";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar/index.js";
import Footer from "examples/Footer";
import MDEditor from "components/MDEditor/index.js";
import noImage from "assets/images/no-image.png";
import EditRow from "./components/EditRow.js"
import { PRODUCT } from 'constants.js';
import CountryOfOrigin from "layouts/components/CountryOfOrigin.js";
import CustomFields from "layouts/components/CustomFields.js";
import MediaUpload from "layouts/components/MediaUpload.js";

function Product() {

  const { productId } = useParams();
  const product_Id = productId ? productId : 0;
  const addPage = (typeof (productId) == 'undefined') ? true : false;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { MyContext } = controller;
  const baseUrl = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [isLoading, setIsLoading] = useState(false);
  const [digitalFileUploadLoading, setDigitalFileUploadLoading] = useState(false);
  const [description, setDescription] = useState('');
  const [responseData, setResponseData] = useState([]);
  const [digitalFileInfo, setDigitalFileInfo] = useState([]);
  const [customFields, setCustomFields] = useState([])
  const [selectedCustomMultiselect, setSelectedCustomMultiselect] = useState([]);
  const [categoryCustomFields, setCategoryCustomFields] = useState([])
  const countries = Country.getAllCountries();
  const [selectedCountryOfOrgin, setSelectedCountryOfOrgin] = useState('0');
  const [selectedDialogCountryOfOrgin, setSelectedDialogCountryOfOrgin] = useState();
  const [collections, setCollections] = useState([]);
  const [collectionId, setCollectionId] = useState([]);
  const [mediaList, setMediaList] = useState([]);
  const [mediaImages, setMediaImages] = useState([]);
  const [mediaLoading, setMediaLoading] = useState(false);
  const [variantMediaLoading, setVariantMediaLoading] = useState(false);
  const [urlPopup, setUrlPopup] = useState(false);
  const [options, setOptions] = useState([]);
  const [showAddVariantOptionButton, setShowAddVariantOptionButton] = useState(true);
  const [showDigitalVariant, setShowDigitalVariant] = useState(false);
  const [variantsList, setVariantsList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [variantErrors, setVariantErrors] = useState('');
  const [digitalProductInfo, setDigitalProductInfo] = useState('')
  const [showOptions, setShowOptions] = useState(false);
  const [focusedTextField, setfocusedTextField] = useState()
  const [counter, setCouter] = useState(1);
  const [vcounter, setVcounter] = useState(1);
  const [editOpen, setEditOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [imagePopup, setImagePopup] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const [dialogDigitalProductInfo, setDialogDigitalProductInfo] = useState({});
  const [dialogDigitalFileInfo, setDialogDigitalFileInfo] = useState([]);
  const [pageReset, setPageReset] = useState(false);
  const [currentScrollHeight, setCurrentScrollHeight] = useState('');


  /* modification for volumetric display */

  const [volumetricWidth, setVolumetricWidth] = useState(0);
  const [volumetricHeight, setVolumetricHeight] = useState(0);
  const [volumetricLength, setVolumetricLength] = useState(0);
  const [volumetricWeight, setVolumetricWeight] = useState(null);

  useEffect(() => {
    if (editOpen) {
      document.documentElement.style.scrollBehavior = "auto";
      document.documentElement.scrollTop = currentScrollHeight;
    }
  }, [editOpen]);


  useEffect(() => {
    if (volumetricWidth > 0 && volumetricHeight > 0 && volumetricLength > 0) {
      const calculatedWeight = (volumetricLength * volumetricHeight * volumetricWidth) / 5000;
      setVolumetricWeight(calculatedWeight);
    } else {
      setVolumetricWeight(null);
    }
  }, [volumetricWidth, volumetricHeight, volumetricLength]);


  const { register, handleSubmit, watch, control, formState: { errors }, setValue, getValues, setError, clearErrors, trigger, reset,
  } = useForm({
    defaultValues: {
      requireShipping: true,
      type: 1
    }
  });

  const types = [
    { label: t('normal'), value: 1 },
    { label: t('digital'), value: 2 },
  ]

  const digitalType = [
    { label: t('digitalProductAsFile'), value: "file" },
    { label: t('digitalProductAsUrl'), value: "url" }
  ]
  const units = [
    { value: "lb", name: "POUNDS(lb)" },
    { value: "oz", name: "OUNCES(oz)" },
    { value: "kg", name: "KILOGRAMS(kg)" },
    { value: "g", name: "GRAMS(g)" },
  ];

  const tracks = [
    { value: 0, name: t("don'tTrackInventory") },
    { value: 1, name: t("trackThisProductInventory") }
  ]

  const optionList = [
    { label: "Size", name: "Size" },
    { label: "Colour", name: "Colour" },
    { label: "Material", name: "Material" },
    { label: "Style", name: "Style" },
  ]
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const fetchProductCreationData = async () => {
    setIsLoading(true);

    await axios.get(baseUrl + '/product/fetch-product-creation-data?dataFrom=product', {
      headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey },
    })
      .then((response) => {
        setIsLoading(false);
        if (response.status == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            let responseData = response.data.data;
            const convertedData = convertToTree(responseData.collections);
            setCollections(convertedData);
            setCategories(responseData.categories);
            setCustomFields(responseData.generalCustomFields);
          }
          else {
            if (message != '')
              toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
            const redirectTimeout = setTimeout(() => {
              clearTimeout(redirectTimeout);
              navigate('/products/manage')
            }, 3000);
          }
        }
        else {
          toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
          const redirectTimeout = setTimeout(() => {
            clearTimeout(redirectTimeout);
            navigate('/products/manage')
          }, 3000);
        }
      }).catch(error => {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }
  const fetchData = async () => {
    setIsLoading(true);
    await axios.get(baseUrl + '/product/view/' + productId, {
      headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey },
    }).then((response) => {
      setIsLoading(false);
      const requestStatus = response.status;
      if (requestStatus == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          const responseData = response.data.data;
          setResponseData(responseData);
          const responseDataDetails = response.data.data.details;
          if (responseDataDetails.type) {
            setValue('type', responseDataDetails.type)
          }
          setValue('gstSlab', (responseDataDetails.gstSlab) ? responseDataDetails.gstSlab : 0)

          if (responseDataDetails.title != null || responseDataDetails.title != '')
            setValue('title', responseDataDetails.title)

          if (responseDataDetails.description != null && responseDataDetails.description != '')
            setDescription(responseDataDetails.description);

          if (responseDataDetails.tags != null && responseDataDetails.tags != '')
            setValue('tags', responseDataDetails.tags);

          if (responseData.generalCustomFields.length > 0) {
            setCustomFields(responseData.generalCustomFields);
            let value = responseData.generalCustomFields;
            value.map((item) => {
              if (item.fieldType == 6) {
                setSelectedCustomMultiselect((selectedCustomMultiselect) => ({
                  ...selectedCustomMultiselect,
                  [item.fieldName]: item.value,
                }));
              }
            })
          }

          if (responseData.categoryCustomFields.length > 0) {
            setCategoryCustomFields(responseData.categoryCustomFields);
            let value = responseData.categoryCustomFields;
            value.map((item) => {
              if (item.fieldType == 6) {
                setSelectedCustomMultiselect((selectedCustomMultiselect) => ({
                  ...selectedCustomMultiselect,
                  [item.fieldName]: item.value,
                }));
              }
            })
          }

          if (responseDataDetails.collections != null && responseDataDetails.collections != '') {
            const convertedData = convertToTree(responseData.collectionArray);
            setCollectionId(JSON.parse(responseDataDetails.collections));
            manipulateDataForDefaultSelected(convertedData, responseDataDetails.collections);
            setCollections(convertedData);

          }
          else {
            const convertedData = convertToTree(responseData.collectionArray);
            setCollections(convertedData);
          }

          if (responseDataDetails.images != null && responseDataDetails.images != '') {
            let images = [];
            images = JSON.parse(responseDataDetails.images).map(item => ({ original: item.mediaURL, thumbnail: '' }));
            setMediaImages(images);
            setMediaList(JSON.parse(responseDataDetails.images));
          }

          if (responseDataDetails.options != null && responseDataDetails.options != '[]') {
            setOptions(JSON.parse(responseDataDetails.options));
            if (JSON.parse(responseDataDetails.options).length < 3)
              setShowAddVariantOptionButton(true);
            setShowDigitalVariant(true);
            setShowOptions(true);
            let maxCounter = 0;
            let maxVCounter = 0;
            JSON.parse(responseDataDetails.options).forEach(item => {
              if (item.counter > maxCounter) {
                maxCounter = item.counter;
              }
              item.values.forEach(value => {
                if (value.vcounter > maxVCounter) {
                  maxVCounter = value.vcounter;
                }
              });
            });
            setCouter(maxCounter + 1)
            setVcounter(maxVCounter + 1)

          }

          if (responseData.variants.length > 0) {
            if (responseData.variants.length == 1 && (responseData.variants[0].title == '' || responseData.variants[0].title == null)) {
              let variantsData = responseData.variants[0];
              setValue('variantId', variantsData.variantId);
              setValue('price', variantsData.price);
              setValue('comparePrice', (variantsData.compareAtPrice == 0) ? '' : variantsData.compareAtPrice)
              setValue('trackInventory', variantsData.trackInventory)
              if (variantsData.trackInventory == 1) {
                setValue('quantity', variantsData.quantity)
                setValue('inventoryPolicy', variantsData.inventoryPolicy)
              }
              setValue('sku', variantsData.sku);
              setValue('barcode', variantsData.barcode);
              setValue('taxable', variantsData.taxable);
              setValue('minPurchaseQuantity', variantsData.minPurchaseQuantity);
              if (variantsData.countryOfOrgin)
                setSelectedCountryOfOrgin(variantsData.countryOfOrgin)

              setValue("hsnCode", variantsData.hsnCode ? variantsData.hsnCode : '')

              setValue('requireShipping', variantsData.shippingRequired)
              if (variantsData.shippingRequired) {
                setValue('weight', (variantsData.weight == 0) ? '' : variantsData.weight)
                setValue('weightUnit', variantsData.weightUnit)
                setValue('width', variantsData.width)
                setValue('dHeight', variantsData.height)
                setValue('length', variantsData.length)
                setVolumetricWidth(variantsData.width);
                setVolumetricHeight(variantsData.height);
                setVolumetricLength(variantsData.length);
              }

              if (variantsData.digitalProductInfo) {
                setDigitalProductInfo(variantsData.digitalProductInfo)
                setDigitalFileInfo(variantsData.digitalProductInfo.fileInfo)
              }
            }
            else {
              if (responseDataDetails.variantData)
                setVariantsList(JSON.parse(responseDataDetails.variantData));
              if (responseDataDetails.type == PRODUCT.DIGITAL)
                setValue('productMultipleOptions', true);
            }
          }

          if (responseData.categories)
            setCategories(responseData.categories);

          if (responseDataDetails.categoryId)
            setValue('categoryId', responseDataDetails.categoryId);

          if (responseDataDetails.status != null || responseDataDetails.status != '')
            setValue('productStatus', responseDataDetails.status);
        }
        else {
          toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
          const redirectTimeout = setTimeout(() => {
            clearTimeout(redirectTimeout);
            navigate('/products/manage')
          }, 3000);
        }
      }
      else {
        toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
        const redirectTimeout = setTimeout(() => {
          clearTimeout(redirectTimeout);
          navigate('/products/manage')
        }, 3000);
      }
    }).catch(error => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  };

  useEffect(() => {

    if ((addPage && !pageReset)) {    /* To reset the form when navigating from edit page to add page */
      reset();
      setResponseData([]);
      setDescription('');
      setMediaList([]);
      setCustomFields([]);
      setOptions([]);
      setVariantsList([]);
      setCategoryCustomFields([]);
      setDigitalFileInfo([]);
      setSelectedCustomMultiselect([]);
      setSelectedCountryOfOrgin('0');
      setCollections([])
      setCollectionId([]);
      setMediaImages([]);
      setCategories([]);
      setDigitalProductInfo('')
      setDialogDigitalFileInfo([]);
      setSelectedRow([])
      setPageReset(true);
      fetchProductCreationData();
    }
  })

  useEffect(() => {

    if (!addPage)
      fetchData();


  }, []);

  const handleDigitalFileUpload = async (event, dataFrom = 'product', variantId = '') => {
    const file = event.target.files[0];
    const fileName = file.name;

    if (file) {
      const base64 = await convertToBase64(file);
      const fileData = { productId: product_Id, fileInfo: base64, fileName: fileName, dataFrom: dataFrom, variantId: variantId };
      setIsLoading(true);
      axios.post(baseUrl + '/product/addDigitalProductFile', fileData, {
        headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
      })
        .then((response) => {
          setIsLoading(false);
          if (response.status == 200) {
            const status = response.data.status;
            const message = response.data.message;
            if (status == 1) {
              let info = [fileName, response.data.data];
              if (dataFrom == "product")
                setDigitalFileInfo(info);
              else
                setDialogDigitalFileInfo(info);
              toast.success(t(message));
            }
            else {
              if (message != '') {
                setValue('digitalFile', '');
                toast.error(t(message));
              }
              if (response && response.data && response.data.errors) {
                const errorData = response.data.errors;
                errorData.forEach((error) => {
                  setError(error.field, {
                    type: 'server',
                    message: t(error.errors[0])
                  });
                });
              }
            }
          }
          else {
            toast.error(t('unableToProccessRequest'));
          }
        })
        .catch(error => {
          setIsLoading(false);
          handleErrors(error, t, navigate);
        });
    }
  }

  function getFilteredOptionsForCombinations(optionListUnfiltered) {
    let optionList = JSON.parse(JSON.stringify(optionListUnfiltered)); // making deep copy
    let newArray = optionList.map(removeEmptyValues);
    newArray = newArray.filter(option => option.values.length > 0);
    return newArray;
  }

  function generateCombinationList(objects, index = 0, currentCombination = {}, combinations = [], deletedOptionLeastVcounter = '', deletedIndex = 0) {
    if (index === objects.length) {
      const combinedValues = Object.values(currentCombination).map((value) => value.value).join('/');
      const combinedKeys = Object.values(currentCombination).map((value) => 'counter' + value.counter + 'vcounter' + value.vcounter).join('');
      /* Prepareing lookup key to copy existing values when a new option is added  or an existing option removed - begin*/
      const combinedKeysTemp = Object.values(currentCombination).map((value) => 'counter' + value.counter + 'vcounter' + value.vcounter).join('-');
      const combinedKeysTempArr = combinedKeysTemp.split("-");
      if (deletedOptionLeastVcounter == '')    //option added
        combinedKeysTempArr.pop();
      else    //option removed
        combinedKeysTempArr.splice(deletedIndex, 0, deletedOptionLeastVcounter);
      const combinedKeysLookup = combinedKeysTempArr.join('');
      /* Prepareing lookup key to copy existing values when a new option is added or an existing option removed - end*/
      let foundObject = {};
      if (combinedKeys && variantsList)
        foundObject = variantsList.find(item => item['id'] === combinedKeys);
      if (!foundObject) { /* Looking up existing combination before adding/deleting new option */
        foundObject = variantsList.find(item => item['id'] === combinedKeysLookup);
      }
      const variantParts = combinedValues.split("/");
      const optionValues = {
        option1: variantParts[0] ? variantParts[0] : null,
        option2: variantParts[1] ? variantParts[1] : null,
        option3: variantParts[2] ? variantParts[2] : null
      }
      if (foundObject) {
        /* ensuring existing variant id is copied  only once when new option is added-begin */
        let foundObjectVariantId = "";
        const hasMatchingVariant = combinations.some(item => item.variantId === foundObject.variantId);
        if (hasMatchingVariant) {
          foundObjectVariantId = ''
        } else {
          foundObjectVariantId = foundObject.variantId
        }
        /* ensuring existing variant id is copied  only once when new option is added -end*/
        combinations.push({
          id: combinedKeys,
          title: combinedValues,
          price: foundObject.price,
          variantId: foundObjectVariantId,
          productId: foundObject.productId,
          options: optionValues,
          quantity: foundObject.quantity,
          sku: foundObject.sku,
          barcode: foundObject.barcode,
          minPurchaseQuantity: foundObject.minPurchaseQuantity,
          trackInventory: foundObject.trackInventory,
          image: foundObject.image,
          imageInfo: foundObject.imageInfo,
          compareAtPrice: foundObject.compareAtPrice,
          shippingRequired: foundObject.shippingRequired,
          weight: foundObject.weight,
          weightUnit: foundObject.weightUnit,
          width: foundObject.width,
          height: foundObject.height,
          length: foundObject.length,
          countryOfOrgin: foundObject.countryOfOrgin,
          hsnCode: foundObject.hsnCode,
          taxable: foundObject.taxable,
          digitalProductInfo: foundObject.digitalProductInfo,
          available: foundObject.available,
          onHand: foundObject.onHand,
        });
      }
      else {
        combinations.push({
          id: combinedKeys,
          title: combinedValues,
          price: '',
          variantId: 0,
          productId: product_Id,
          options: optionValues,
          quantity: '',
          sku: null,
          barcode: null,
          minPurchaseQuantity: 1,
          trackInventory: 0,
          image: "",
          imageInfo: {},
          compareAtPrice: '',
          shippingRequired: (getValues('type') == 1) ? true : false,
          weight: '',
          weightUnit: 'kg',
          width: '',
          height: '',
          length: '',
          countryOfOrgin: '0',
          hsnCode: '',
          taxable: true,
          digitalProductInfo: {},
          available: 0,
          onHand: 0,

        });
      }
      return;
    }

    const currentObject = objects[index];
    for (const value of currentObject.values) {
      value.counter = currentObject.counter
      const updatedCombination = { ...currentCombination, [currentObject.name]: value };
      generateCombinationList(objects, index + 1, updatedCombination, combinations, deletedOptionLeastVcounter, deletedIndex);
    }
    return combinations;
  }

  const handleSelectCollections = (selectedNode) => {
    let ids = [...collectionId];
    if (ids.includes(selectedNode.value))
      ids = ids.filter(item => item !== selectedNode.value);
    else
      ids.push(selectedNode.value)
    setCollectionId(ids);
    setValue('collectionId', ids);
    manipulateDataForDefaultSelected(collections, ids);
  };

  const handleProductMediaUpload = (fileObjs, imageFrom = 'product', variant = '') => {

    const fileData = { id: product_Id, dataFrom: imageFrom, variantId: variant, mediaSource: 'file', imageData: fileObjs[0].data, name: fileObjs[0].file.name };
    if (imageFrom == 'product')
      setMediaLoading(true);
    else
      setVariantMediaLoading(true);
    axios.post(baseUrl + '/product/addMedia', fileData, {
      headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
    }).then((response) => {
      if (imageFrom == 'product')
        setMediaLoading(false);
      else
        setVariantMediaLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          let mList = [...mediaList];
          const lastInsertedPosition = mList.reduce((maxPosition, item) => {
            return Math.max(maxPosition, item.position);
          }, 0);
          let mediaData = { mediaURL: response.data.data.mediaURL, position: addPage ? (lastInsertedPosition + 1) : response.data.data.position, mediaType: response.data.data.mediaType, id: response.data.data.azureImageId }
          mList.push(mediaData);
          if (imageFrom == 'product')
            setMediaList(mList);
          else {
            selectedRow.imageInfo = mediaData
            selectedRow.image = response.data.data.mediaURL;
          }
        }
        else {
          if (message != '')
            toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
          if (response && response.data && response.data.errors) {
            const errorData = response.data.errors;
            errorData.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: t(error.errors[0])
              });
            });
          }
        }
      }
      else {
        toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
      }
    }).catch(error => {
      if (imageFrom == 'product')
        setMediaLoading(false);
      else
        setVariantMediaLoading(false);
      handleErrors(error, t, navigate);
    });
  };

  const handleProductMediaDelete = (e, index, imageFrom = 'product', variant = '') => {
    let mList = [...mediaList];
    let fileData = {};
    if (index != -1)  // delete product image
      fileData = { productId: product_Id, dataFrom: imageFrom, variantId: variant, id: mList[index].id, position: mList[index].position, mediaURL: mList[index].mediaURL };
    else              //delete variant image
      fileData = { productId: product_Id, dataFrom: imageFrom, variantId: variant, id: selectedRow.imageInfo.id, position: selectedRow.imageInfo.position, mediaURL: selectedRow.imageInfo.mediaURL };
    if (imageFrom == 'product')
      setMediaLoading(true);
    else
      setVariantMediaLoading(true);

    axios.post(baseUrl + '/product/deleteProductMedia', fileData, {
      headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
    }).then((response) => {
      if (imageFrom == 'product')
        setMediaLoading(false);
      else
        setVariantMediaLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          if (index != -1) {
            mList.splice(index, 1);
            setMediaList(mList);
          }
          else {
            selectedRow.imageInfo = '';
            selectedRow.image = '';
            setSelectedRow(selectedRow);
          }
          toast.success(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
        }
        else {
          if (message != '')
            toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
          if (response && response.data && response.data.errors) {
            const errorData = response.data.errors;
            errorData.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: t(error.errors[0])
              });
            });
          }
        }
      }
      else {
        toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
      }
    }).catch(error => {
      if (imageFrom == 'product')
        setMediaLoading(false);
      else
        setVariantMediaLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  const handleMediaUrlOpen = () => {
    setUrlPopup(true);
  }

  useEffect(() => {
    if (options.length < 3)
      setShowAddVariantOptionButton(true);
    else
      setShowAddVariantOptionButton(false);
    if (document.getElementById(focusedTextField) != null)
      document.getElementById(focusedTextField).focus();
  }, [options])

  function removeEmptyValues(entry) {
    entry.values = entry.values.filter(optionValue => optionValue.value !== '');
    return entry;
  }

  const handleOptionNameType = (value, index) => {
    let optionsList = [...options];
    optionsList[index].optionNameType = value;
    setOptions(optionsList);
  }

  const handleAddOptions = event => {
    event.preventDefault();
    setOptions([...options, { name: '', position: '', counter: "", optionNameType: 1, values: [], nameError: '', hidden: false }]);
    setfocusedTextField('')
    setShowOptions(true);
  }

  const handleDeleteOption = (e, index) => {
    let smallestKey = '';
    let optionsList = [...options];
    if ((optionsList[index].values).length > 0) {
      smallestKey = `counter${optionsList[index].counter}vcounter${optionsList[index].values[0].vcounter}`
    }
    optionsList.splice(index, 1);
    setOptions(optionsList);
    if (optionsList.length > 0) {
      const optionValueCombinations = generateCombinationList(getFilteredOptionsForCombinations(optionsList), 0, {}, [], smallestKey, index);
      setVariantsList(optionValueCombinations);
    }
    else {
      setVariantsList([]);
    }
  }

  const handleAddOrChangeOptionName = (data, index) => {
    let value = data ? data : "";
    let optionsList = [...options];
    if (value) {
      let exist = 0;
      let valueCount = 0;
      for (const item of optionsList) {
        if (item.name == value && valueCount != index) {
          exist = 1;
          break;
        }
        valueCount++;
      }
      if (exist == 1) {
        optionsList[index].nameError = t('optionNameAlreadyUsed');
      }
      else {
        if (!optionsList[index].counter) {
          optionsList[index].counter = counter;
          setCouter(counter + 1);
        }
        if (!optionsList[index].position)
          optionsList[index].position = index + 1;
        optionsList[index].nameError = '';
      }
      optionsList[index].name = value;
    }
    else {
      optionsList[index].nameError = t('optionNameRequired');
      optionsList[index].name = '';
    }
    const empty = optionsList[index].values.find(item => item['value'] === '');
    if (!empty) {
      optionsList[index].values.push({ "value": "", "vcounter": "", "vposition": "" });
    }
    setOptions(optionsList);
  }

  const handleAddOrChangeOptionValue = (value, valueIndex, nameIndex) => {
    let optionsList = [...options];
    let valuePointer = 0;
    if (value) {
      let exist = 0;
      for (const item of optionsList[nameIndex].values) {
        if (item.value == value && valuePointer != valueIndex) {
          exist = 1;
          break;
        }
        valuePointer++;
      }
      if (exist == 1) {
        let optionValue = {};
        if (optionsList[nameIndex].values[valueIndex]) {
          optionValue = optionsList[nameIndex].values[valueIndex];
        }
        optionValue.value = value;
        optionsList[nameIndex].values[valueIndex] = optionValue;
        optionsList[nameIndex].valueError = t('alreadyUsedOptionValue');
      }
      else {
        let optionValue = {};
        if (optionsList[nameIndex].values[valueIndex]) {
          optionValue = optionsList[nameIndex].values[valueIndex];
        }
        if (optionValue.vcounter == "") {
          optionValue.vcounter = vcounter;
          setVcounter(vcounter + 1);
        }
        if (!optionValue.vposition) {
          optionValue.vposition = valueIndex + 1;
        }
        optionValue.value = value;
        optionsList[nameIndex].values[valueIndex] = optionValue;
        optionsList[nameIndex].valueError = '';
      }

      const empty = optionsList[nameIndex].values.find(item => item['value'] === '');
      if (!empty) {
        optionsList[nameIndex].values.push({ "value": "", "vcounter": "", "vposition": "" });
      }
    }
    else {
      optionsList[nameIndex].valueError = t('optionValueRequired');
    }
    setOptions(optionsList);
  }


  const handleRemoveLastDuplicateOptionValue = (value, valueIndex, nameIndex) => {
    let optionsList = [...options];
    let optionName = optionsList[nameIndex].name;
    let valuePointer = 0;
    if (value) {
      let exist = 0;
      for (const item of optionsList[nameIndex].values) {
        if (item.value == value && valuePointer != valueIndex) {
          exist = 1;
          break;
        }
        valuePointer++;
      }
      if (exist == 1) {
        optionsList[nameIndex].values.splice(valueIndex, 1);
        optionsList[nameIndex].valueError = '';
        setOptions(optionsList)
      }
      const optionValueCombinations = generateCombinationList(getFilteredOptionsForCombinations(optionsList));
      setVariantsList(optionValueCombinations);
    }
  }

  const handleDeleteOptionValue = (e, valueIndex, nameIndex) => {
    let optionsList = [...options];
    const smallestKey = (optionsList[nameIndex].values.length == 2) ?
      `counter${optionsList[nameIndex].counter}vcounter${optionsList[nameIndex].values[0].vcounter}`
      : '';
    optionsList[nameIndex].values.splice(valueIndex, 1);
    setOptions(optionsList)
    const optionValueCombinations = generateCombinationList(getFilteredOptionsForCombinations(optionsList), 0, {}, [], smallestKey, nameIndex);
    setVariantsList(optionValueCombinations);
  }

  const handleShowOptionDetails = (e, index) => {
    let optionsList = [...options];
    optionsList[index].hidden = !(optionsList[index].hidden);
    setOptions(optionsList);
  }

  const handleVariantEdit = (rowId) => {
    setCurrentScrollHeight(document.documentElement.scrollTop);
    const row = variantsList[rowId];
    setValue('dialogPrice', row.price)
    setValue('dialogComparePrice', (row.compareAtPrice == 0) ? '' : row.compareAtPrice)
    setValue('dialogTaxable', row.taxable)
    setValue('dialogSku', row.sku)
    setValue('dialogBarcode', row.barcode)
    setValue('dialogMinPurchaseQuantity', row.minPurchaseQuantity)
    setValue('dialogTrackInventory', row.trackInventory)
    setValue('dialogQuantity', row.quantity)
    setValue('dialogInventoryPolicy', row.inventoryPolicy)
    setValue('dialogRequireShipping', row.shippingRequired)
    setValue('dialogWeight', (row.weight == 0) ? '' : row.weight)
    setValue('dialogWeightUnit', row.weightUnit)
    setValue('dialogWidth', row.width ? row.width : '')
    setValue('dialogHeight', row.height ? row.height : '')
    setValue('dialogLength', row.length ? row.length : '')
    setDialogDigitalProductInfo(row.digitalProductInfo ? row.digitalProductInfo : {})
    setValue('dialogDigitalType', (row.digitalProductInfo && row.digitalProductInfo.type) ? row.digitalProductInfo.type : 'file')
    setValue('dialogDigitalProductFileLink', (row.digitalProductInfo && row.digitalProductInfo.fileUrl) ? row.digitalProductInfo.fileUrl : '')
    setValue('dialogNumberOfAccessibleDays', (row.digitalProductInfo && row.digitalProductInfo.noOfAccessDays) ? row.digitalProductInfo.noOfAccessDays : 0)
    setValue('dialogNumberOfDownloads', (row.digitalProductInfo && row.digitalProductInfo.noOfDownloads) ? row.digitalProductInfo.noOfDownloads : 0)
    setDialogDigitalFileInfo((row.digitalProductInfo && row.digitalProductInfo.fileInfo) ? row.digitalProductInfo.fileInfo : {})
    setValue('dialogCountryOfOrgin', row.countryOfOrgin ? row.countryOfOrgin : '0')
    setValue('dialogHsnCode', row.hsnCode ? row.hsnCode : '')
    setSelectedRow(row);
    setEditOpen(true);
  };
  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode, //let's use the same dark/light mode as the global theme
          primary: globalTheme.palette.secondary, //swap in the secondary color as the primary for the table
          info: {
            main: 'rgb(255,122,0)', //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === 'light'
                ? 'rgb(254,255,244)' //random light yellow color for the background in light mode
                : '#000', //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: 'none', //customize typography styles for all buttons in table by default
            fontSize: '1.2rem',
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: '1.1rem', //override to make tooltip font size larger
              },
            },
          },
          MuiSwitch: {
            styleOverrides: {
              thumb: {
                color: 'pink', //change the color of the switch thumb in the columns show/hide menu to pink
              },
            },
          },
        },
      }),
    [globalTheme],
  );

  const DataTable = () => {
    const columns = useMemo(() => {
      const baseColumns = [
        {
          accessorKey: 'image',
          header: t('mediaUrlTitle'),
          Cell: ({ renderedCellValue }) => (
            <img
              alt=""
              height={30}
              src={renderedCellValue ? renderedCellValue : noImage}
            />
          ),
          size: 50,
        },
        {
          accessorKey: 'title',
          header: t('variants'),
          size: 150,
        },
        {
          accessorKey: 'price',
          header: t('price'),
          size: 100,
        },
        {
          accessorKey: 'sku',
          header: t('sku'),
          size: 100,
        },
      ];

      if (getValues('type') == PRODUCT.NORMAL) {
        // Append 'weight' and 'quantity' columns when type is 1
        baseColumns.push(
          {
            accessorKey: 'weight',
            header: t('weight'),
            size: 100,
          },
          {
            accessorKey: 'quantity',
            header: t('quantity'),
            size: 100,
          }
        );
      }

      return baseColumns;
    }, [getValues('type')]);

    return (
      <>
        <MDBox className="DataTableStyle" >
          <ThemeProvider theme={tableTheme}>
            <MaterialReactTable
              columns={columns}
              data={variantsList}
              enableRowOrdering={false}
              enableSorting={false}
              enableRowActions
              positionActionsColumn="last"
              enableBottomToolbar={false}
              enableTopToolbar={false}
              enablePagination={false}
              enableColumnActions={false}
              columnResizeMode={false}
              enableDensityToggle={false}
              enableExpandAll={false}
              enableExpanding={false}
              enableFilterMatchHighlighting={false}
              enableFilters={false}
              enableFullScreenToggle={false}
              enableHiding={false}
              renderRowActions={({ row, table }) => (
                <Box className="ActionMainBox">
                  <IconButton
                    color="secondary"
                    onClick={(e) => {
                      handleVariantEdit(row.id);
                    }}
                    disableRipple
                  >
                    <Tooltip title={t('Edit')}><Box className="ActionEdit"><EditIcon className="generalFont" /></Box></Tooltip>
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => {
                      variantsList.splice(row.index, 1);
                      setVariantsList([...variantsList]);
                    }}
                    disableRipple
                  >
                    <Tooltip title={t('Delete')} className="paddingRight5"><Box className="ActionDelete"><DeleteIcon className="generalFont" /></Box></Tooltip>
                  </IconButton>
                </Box>
              )}
              muiTableBodyRowDragHandleProps={({ table }) => ({
                onDragEnd: () => {
                  const { draggingRow, hoveredRow } = table.getState();
                  if (hoveredRow && draggingRow) {
                    variantsList.splice(
                      hoveredRow.index,
                      0,
                      variantsList.splice(draggingRow.index, 1)[0],
                    );
                    setVariantsList([...variantsList]);
                  }
                },
              })}
            />
          </ThemeProvider>
        </MDBox>
      </>
    )
  }

  const Variant = () => {
    return (
      <Grid item xs={12}>
        <Card >
          <Grid container spacing={2} alignItems="center" sx={{ p: 3 }} >
            <Grid item xs={12}>
              <MDTypography variant="h6" className="uppercaseLetters" >{t('variants')}</MDTypography>
              <MDTypography component="span" variant="body2" >{t('variantsDetails')}</MDTypography>
            </Grid>
            <Grid item xs={12}>
              {
                (showOptions) ?
                  options.map((item, index) => (
                    <MDBox key={index}>
                      {item.hidden ?
                        <Grid item key={index} xs={12}>
                          <Grid item xs={12}>
                            <MDTypography variant="body1" className="labelStyle optionNameStyle" >{item.name}</MDTypography>
                          </Grid>
                          <Grid item xs={12} mb={1}>
                            {
                              item.values.map((optionValue, i) => {
                                return (
                                  <MDTypography key={i} variant="body1" className="labelStyle optionValueStyle" >{optionValue.value}</MDTypography>
                                )
                              }
                              )}
                            <MDButton className="optionValueEditButton" onClick={e => { handleShowOptionDetails(e, index) }} disableRipple>{t('edit')}</MDButton>
                          </Grid>
                        </Grid>
                        :
                        <Grid item key={index} xs={12}>
                          <Grid container spacing={2} >
                            <Grid item xs={12} sm={4} md={4}>
                              <MDTypography variant="body1" className="labelStyle">{t('optionName')}</MDTypography>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8}>
                              <RadioGroup
                                aria-labelledby="selectOptionNameType"
                                value={item.optionNameType}
                                name={"optionNameType" + index}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  handleOptionNameType(value, index)
                                }}
                                row
                              >
                                <FormControlLabel className="radioButtonIcon" value="1" control={<Radio />} label={t("predefined")} />
                                <FormControlLabel className="radioButtonIcon" value="2" control={<Radio />} label={t("custom")} />
                              </RadioGroup>
                              {item.nameError && <span className="errorMsg FloatRight">{item.nameError}</span>}
                            </Grid>
                            < Grid item xs={12} sm={4} md={4}>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8}>
                              <MDBox className="PositionRelative" mb={1}>
                                {item.optionNameType == "1" ? (
                                  <>
                                    <MDInput
                                      select
                                      name={"optionName" + index}
                                      key={"optionName" + index}
                                      id={"optionName" + index}
                                      InputProps={{
                                        classes: { root: "select-input-styles " },
                                      }}
                                      value={item.name || ''}
                                      onChange={(e) => {
                                        e.stopPropagation()
                                        setfocusedTextField("optionName" + index);
                                        handleAddOrChangeOptionName(e.target.value, index)
                                      }}
                                      onBlur={(e) => {
                                        e.stopPropagation()
                                        setfocusedTextField('');
                                        handleAddOrChangeOptionName(e.target.value, index)
                                      }}
                                      fullWidth
                                    >
                                      {optionList.map((option) => (
                                        <MenuItem key={option.label} value={option.name}>{option.name}</MenuItem>
                                      ))}
                                    </MDInput>
                                    <Tooltip title={t('deleteOption')} arrow   >
                                      <IconButton
                                        size="small"
                                        disableRipple
                                        className="deleteOption"
                                        variant="contained"
                                        onClick={(e) => { handleDeleteOption(e, index) }}
                                      >
                                        <Icon >delete</Icon>
                                      </IconButton>
                                    </Tooltip>
                                  </>
                                ) : (
                                  <>
                                    <MDInput
                                      type="text"
                                      key={"optionName" + index}
                                      id={"optionName" + index}
                                      name={"optionName" + index}
                                      value={item.name || ''}
                                      InputProps={{
                                        classes: { root: "inputBoxStyle" },
                                      }}
                                      onChange={((e) => {
                                        e.stopPropagation()
                                        setfocusedTextField("optionName" + index);
                                        handleAddOrChangeOptionName(e.target.value, index)
                                      })}
                                      onBlur={((e) => {
                                        setfocusedTextField('');
                                        handleAddOrChangeOptionName(e.target.value, index)
                                      })}
                                      fullWidth />
                                    <Tooltip title={t('deleteOption')} arrow   >
                                      <IconButton
                                        size="small"
                                        disableRipple
                                        className="deleteOption"
                                        variant="contained"
                                        onClick={(e) => { handleDeleteOption(e, index) }}
                                      >
                                        <Icon >delete</Icon>
                                      </IconButton>
                                    </Tooltip>
                                  </>
                                )}
                              </MDBox>
                            </Grid>
                          </Grid>
                          <Grid container spacing={2} >
                            <Grid item xs={12} sm={4} md={4}>
                              <MDTypography variant="body1" className="labelStyle" >{t('optionValue')}</MDTypography>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8}>
                              {item.valueError && (<span className="errorMsg FloatRight">{item.valueError}</span>)}
                              {
                                item.values.map((option, i) => (
                                  <MDBox key={i} className="PositionRelative" mb={1}>
                                    <MDInput
                                      type="text"
                                      key={"option" + index + "value" + i}
                                      id={"option" + index + "value" + i}
                                      name="optionValue"
                                      value={option.value}
                                      InputProps={{
                                        classes: { root: "inputBoxStyle" },
                                        autoComplete: "off",
                                      }}
                                      onChange={e => {
                                        setfocusedTextField("option" + index + "value" + i);
                                        handleAddOrChangeOptionValue(e.target.value, i, index)
                                      }}
                                      onBlur={e => {
                                        handleRemoveLastDuplicateOptionValue(e.target.value, i, index);
                                      }}
                                      fullWidth
                                    />
                                    {item.values.length - 1 != i ?
                                      <Tooltip title={t('deleteOptionValue')} arrow  >
                                        <IconButton
                                          size="small"
                                          disableRipple
                                          className="deleteOptionValue"
                                          variant="contained"
                                          onClick={(e) => { handleDeleteOptionValue(e, i, index) }}
                                        >
                                          <Icon >delete</Icon>
                                        </IconButton>
                                      </Tooltip>
                                      : null}
                                  </MDBox>
                                )
                                )
                              }
                              {item.values.length > 1 ?
                                <MDButton className="optionValueDoneButton" onClick={e => { handleShowOptionDetails(e, index) }} disableRipple>{t('done')}</MDButton>
                                : null
                              }</Grid>
                          </Grid>
                        </Grid>
                      }
                    </MDBox>
                  )
                  )
                  : null
              }
            </Grid>
            {
              showAddVariantOptionButton ?
                <Grid item xs={12}>
                  <IconButton
                    name="addVariant"
                    size="small"
                    disableRipple
                    className="labelStyle"
                    color="info"
                    onClick={handleAddOptions}
                  >
                    <Icon >add</Icon> {options.length > 0 ? t('addAnotherOption') : t('addOptions')}
                  </IconButton>
                </Grid>
                :
                null
            }
            {
              (variantsList && variantsList.length > 0) ?
                <><Grid item xs={12}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12}>
                      <MDTypography variant="h6" className="uppercaseLetters">{t('variantCombinations')}</MDTypography>
                      {variantErrors && (<span className="errorMsg FloatRight">{variantErrors}</span>)}
                    </Grid>
                    <Grid item xs={12}>
                      <DataTable className="VariantCombinationsDataTable" />
                    </Grid>
                  </Grid>
                </Grid>
                  {editOpen ?
                    <EditRow
                      urlPopup={urlPopup}
                      selectedRow={selectedRow}
                      t={t}
                      productId={product_Id}
                      setUrlPopup={setUrlPopup}
                      handleErrors={handleErrors}
                      navigate={navigate}
                      mediaList={mediaList}
                      setMediaList={setMediaList}
                      setSelectedRow={setSelectedRow}
                      variantMediaLoading={variantMediaLoading}
                      responseData={responseData}
                      tracks={tracks}
                      selectedDialogCountryOfOrgin={selectedDialogCountryOfOrgin}

                      countries={countries}
                      MyContext={MyContext}
                      handleProductMediaDelete={handleProductMediaDelete}
                      DropzoneAreaBase={DropzoneAreaBase}
                      fileTypes={PRODUCT.FILETYPES}
                      handleMediaUrlOpen={handleMediaUrlOpen}
                      handleProductMediaUpload={handleProductMediaUpload}
                      setSelectedDialogCountryOfOrgin={setSelectedDialogCountryOfOrgin}

                      setVariantErrors={setVariantErrors}
                      errors={errors}
                      register={register}
                      watch={watch}
                      control={control}
                      setValue={setValue}
                      getValues={getValues}
                      setError={setError}
                      clearErrors={clearErrors}
                      trigger={trigger}
                      variantsList={variantsList}
                      setVariantsList={setVariantsList}
                      setEditOpen={setEditOpen}
                      setDialogDigitalProductInfo={setDialogDigitalProductInfo}
                      setDialogDigitalFileInfo={setDialogDigitalFileInfo}
                      dialogDigitalProductInfo={dialogDigitalProductInfo}
                      digitalType={digitalType}
                      digitalFileUploadLoading={digitalFileUploadLoading}
                      dialogDigitalFileInfo={dialogDigitalFileInfo}
                      units={units}
                      handleDigitalFileUpload={handleDigitalFileUpload}
                      isURL={isURL}
                      toast={toast}
                      setIsLoading={setIsLoading}
                    />
                    :
                    null}
                </>
                :
                null
            }
          </Grid>
        </Card>
      </Grid>
    )
  }

  const handleButtonClick = (isSubmit) => {
    if (isSubmit) {
      handleSubmit(onSubmit);
    } else {
      onDraft();
    }
  };

  const submitData = async (inputData) => {
    setIsLoading(true)
    axios.post(baseUrl + '/product/save', inputData, {
      headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
    }).then((response) => {
      setIsLoading(false)
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          toast.success(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
          if (response.data.variantErrors && response.data.variantErrors.length > 0)
            setVariantErrors(t('variantErrors'));
          else {
            const redirectTimeout = setTimeout(() => {
              clearTimeout(redirectTimeout);
              navigate(`/products/manage`);
            }, 2000);
          }
        }
        else {
          if (message != '')
            toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
          if (response && response.data && response.data.errors) {
            const errorData = response.data.errors;
            errorData.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: t(error.errors[0])
              });
            });
          }
        }
      }
      else {
        toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
      }
    }).catch(error => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  const onDraft = async () => {
    const isValidtype = await trigger('type');
    const isValidProductName = await trigger('title')
    const isValidPrice = await trigger('price');
    const isValidComparePrice = await trigger('comparePrice');
    const isValidQuantity = await trigger('quantity');
    const isValidWidth = await trigger('width');
    const isValidHeight = await trigger('dHeight');
    const isValidLength = await trigger('length');
    const isValidNumberOfAccessibleDays = await trigger('numberOfAccessibleDays');
    const isValidNumberOfDownloads = await trigger('numberOfDownloads');
    const isValidDigitalProductFileLink = await trigger('productFileLink');
    const isValidDigitalFile = await trigger('digitalFile');
    const isValidCategoryId = await trigger('categoryId')

    if (isValidtype && isValidProductName && isValidPrice && isValidComparePrice
      && isValidQuantity && isValidWidth && isValidHeight && isValidLength && isValidNumberOfAccessibleDays
      && isValidNumberOfDownloads && isValidDigitalProductFileLink && isValidDigitalFile && isValidCategoryId) {
      let inputData = {};
      inputData.id = product_Id;
      inputData.title = getValues('title')
      inputData.description = description
      inputData.type = getValues('type')
      inputData.gstSlab = getValues('gstSlab')
      inputData.productTags = getValues('tags')
      inputData.categoryId = getValues('categoryId')
      inputData.images = mediaList;
      inputData.collectionId = collectionId;
      inputData.options = options;
      const customFieldData = processCustomFields(
        customFields,
        selectedCustomMultiselect,
        getValues
      );
      inputData.generalCustomFields = customFieldData;

      const categoryCustomFieldsData = processCustomFields(
        categoryCustomFields,
        selectedCustomMultiselect,
        getValues
      );
      inputData.categoryCustomFields = categoryCustomFieldsData;

      inputData.saveType = PRODUCT.DRAFT;
      let vList = [];
      if (variantsList && variantsList.length > 0) {
        let errorFlag = 0;
        variantsList.forEach(element => {
          if (element.price == '' || element.price == 0)
            errorFlag = 1;
          else if (element.trackInventory && (element.quantity == '' || element.quantity == 0))
            errorFlag = 1;
        });
        if (errorFlag == 1) {
          setVariantErrors(t('variantErrors'))
          return;
        }
        else {
          inputData.variants = variantsList;
          setVariantErrors(t(''))
        }
      }
      else {
        let list = {};
        list.price = parseFloat(getValues("price"));
        list.minPurchaseQuantity = getValues('minPurchaseQuantity');
        list.countryOfOrgin = selectedCountryOfOrgin;
        list.hsnCode = getValues('hsnCode');;
        list.trackInventory = getValues('trackInventory');
        getValues('trackInventory') ?
          (
            list.quantity = getValues("quantity"),
            list.inventoryPolicy = getValues("inventoryPolicy")
          )
          : null
        list.compareAtPrice = getValues("comparePrice") ? parseFloat(getValues("comparePrice")) : 0;
        list.sku = getValues("sku");
        list.barcode = getValues("barcode");
        if (getValues('type') == 1) {
          getValues("requireShipping") ?
            (
              list.shippingRequired = getValues("requireShipping"),
              list.weight = getValues("weight") ? parseFloat(getValues("weight")) : '',
              list.weightUnit = getValues("weightUnit"),
              list.width = parseFloat(getValues("width")),
              list.height = parseFloat(getValues("dHeight")),
              list.length = parseFloat(getValues("length"))
            )
            : null
        }
        else {
          if (getValues('digitalType') == 'file') {
            list.digitalProductInfo = { type: getValues('digitalType'), noOfAccessDays: getValues('numberOfAccessibleDays'), noOfDownloads: getValues('numberOfDownloads'), fileInfo: digitalFileInfo }
          }
          else {
            list.digitalProductInfo = { type: getValues('digitalType'), noOfAccessDays: getValues('numberOfAccessibleDays'), noOfDownloads: getValues('numberOfDownloads'), fileUrl: getValues('digitalProductFileLink') }
          }
        }
        list.taxable = getValues("taxable");
        vList.push(list)
        inputData.variants = vList;
      }
      submitData(inputData);
    }

  }

  const onSubmit = async (data) => {
    let inputData = {};
    inputData.id = product_Id;
    inputData.title = data['title']
    inputData.description = description
    inputData.type = getValues('type')
    inputData.gstSlab = data['gstSlab']
    inputData.productTags = data['tags']
    inputData.categoryId = data['categoryId'];
    inputData.images = mediaList;
    inputData.collectionId = collectionId;
    inputData.options = options;
    const customFieldData = processCustomFields(
      customFields,
      selectedCustomMultiselect,
      getValues
    );
    inputData.generalCustomFields = customFieldData;

    const categoryCustomFieldsData = processCustomFields(
      categoryCustomFields,
      selectedCustomMultiselect,
      getValues
    );
    inputData.categoryCustomFields = categoryCustomFieldsData;

    inputData.saveType = PRODUCT.SUBMIT;
    let vList = [];
    if (variantsList && variantsList.length > 0) {
      let errorFlag = 0;
      variantsList.forEach(element => {
        if (element.price == '' || element.price == 0)
          errorFlag = 1;
        else if (element.trackInventory && (element.quantity == '' || element.quantity == 0))
          errorFlag = 1;
      });
      if (errorFlag == 1) {
        setVariantErrors(t('variantErrors'))
        return;
      }
      else {
        inputData.variants = variantsList;
        setVariantErrors(t(''))
      }
    }
    else {
      let list = {};
      list.variantId = data['variantId'];
      list.price = parseFloat(data["price"]);
      list.minPurchaseQuantity = data['minPurchaseQuantity'];
      list.countryOfOrgin = selectedCountryOfOrgin;
      list.hsnCode = data['hsnCode'];
      list.trackInventory = data['trackInventory'];
      data['trackInventory'] ?
        (
          list.quantity = data["quantity"],
          list.inventoryPolicy = data["inventoryPolicy"]
        )
        : null
      list.compareAtPrice = data["comparePrice"] ? parseFloat(data["comparePrice"]) : 0;
      list.sku = data["sku"];
      list.barcode = data["barcode"];
      if (data['type'] == 1) {
        data['requireShipping'] ?
          (
            list.shippingRequired = data['requireShipping'],
            list.weight = data["weight"] ? parseFloat(data["weight"]) : '',
            list.weightUnit = data["weightUnit"],
            list.width = parseFloat(data["width"]),
            list.height = parseFloat(data["dHeight"]),
            list.length = parseFloat(data["length"])
          )
          : null
      }
      else {
        if (data['digitalType'] == 'file') {
          list.digitalProductInfo = { type: data['digitalType'], noOfAccessDays: data['numberOfAccessibleDays'], noOfDownloads: data['numberOfDownloads'], fileInfo: digitalFileInfo }
        }
        else {
          list.digitalProductInfo = { type: data['digitalType'], noOfAccessDays: data['numberOfAccessibleDays'], noOfDownloads: data['numberOfDownloads'], fileUrl: data['digitalProductFileLink'] }
        }
      }
      list.taxable = data["taxable"];
      vList.push(list)
      inputData.variants = vList;
    }
    submitData(inputData);
  }

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={addPage ? t('addProduct') : t('editProduct')} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
      <MDBox mt={3} component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
        <Grid item xs={12} md={12} lg={12}>
          <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Grid container spacing={2}>
              <Grid item xs={12}> {/* product details */}
                <Card visible="true" className="productDetails">
                  <Grid container spacing={2} alignItems="center" sx={{ p: 3 }}>
                    <Grid item xs={12}>
                      <MDTypography variant="h6" className="uppercaseLetters">{t('productDetails')}</MDTypography>
                      <MDTypography component="span" variant="body2" >{t('addProductDetailsHere')}</MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <MDTypography variant="body1" className="labelStyle">{t('chooseProduct')}
                        <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Controller
                        name="type"
                        control={control}
                        defaultValue={1}
                        rules={{
                          required: {
                            value: true,
                            message: t('typeRequired')
                          },
                          validate: (value) => {
                            if (value === 0) {
                              return t('typeRequired');
                            }
                            return true;
                          },
                        }}
                        render={({ field }) => (
                          <MDInput
                            select
                            {...field}
                            fullWidth
                            InputProps={{
                              classes: { root: "select-input-styles select-padding-0" },
                              disabled: (responseData && responseData.details && responseData.details.type) ? true : false
                            }}
                          >
                            {types.map((type) => (
                              <MenuItem key={type.value} value={type.value}>
                                {type.label}
                              </MenuItem>
                            ))}
                          </MDInput>
                        )}
                      />
                      {errors.type && (
                        <span className="errorMsg FloatRight">{errors.type.message}</span>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <MDTypography variant="body1" className="labelStyle">{t('productName')}
                        <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <MDInput
                        type="text"
                        name="title"
                        placeholder={t('enterProductName')}
                        InputProps={{
                          classes: { root: "inputBoxStyle" },
                        }}
                        {...register("title", {
                          required: {
                            value: true,
                            message: t('titleRequired')
                          }
                        })}
                        onChange={((e) => {
                          e.stopPropagation();
                          if ((e.target.value).length != 0) {
                            setValue('title', (e.target.value).charAt(0).toUpperCase() + (e.target.value).slice(1));
                          }
                        })}
                        fullWidth />
                      {errors.title && (<span className="errorMsg FloatRight">{errors.title.message}</span>)}
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <MDTypography variant="body1" className="labelStyle">{t('description')}</MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      {((responseData && responseData.details) || addPage) &&
                        <MDEditor
                          value={description}
                          onChange={(updatedContent) => {
                            setDescription(updatedContent);
                          }}
                        />
                      }
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <MDTypography variant="body1" className="labelStyle">{t('productTags')}</MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <MDInput
                        type="text"
                        name="tags"
                        InputProps={{
                          classes: { root: "inputBoxStyle" },
                        }}
                        {...register("tags")}
                        onChange={((e) => { e.stopPropagation() })}
                        fullWidth />
                      <MDTypography component="span" variant="body2" color="info">{t('productTagsNotes')}</MDTypography>
                      {errors.tags && (<span className="errorMsg FloatRight">{errors.tags.message}</span>)}
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <MDTypography variant="body1" className="labelStyle">{t('collections')}</MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <TreeSelect data={collections} onSelect={handleSelectCollections} selected={collectionId} />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item xs={12}>{/* media */}
                <Card >
                  <Grid container spacing={2} alignItems="center" sx={{ p: 3 }}>
                    <Grid item xs={12}>
                      <MDTypography variant="h6" className="uppercaseLetters" >{t('media')}</MDTypography>
                    </Grid>
                    <Grid item xs={12}>
                      <MediaUpload
                        mediaList={mediaList}
                        mediaLoading={mediaLoading}
                        setMediaLoading={setMediaLoading}
                        setVariantMediaLoading={setVariantMediaLoading}
                        urlPopup={urlPopup}
                        imageFrom="product"
                        selectedRow={selectedRow}
                        product_Id={product_Id}
                        variantId={''}
                        setUrlPopup={setUrlPopup}
                        setMediaList={setMediaList}
                        setSelectedRow={setSelectedRow}
                        register={register}
                        watch={watch}
                        control={control}
                        setValue={setValue}
                        getValues={getValues}
                        setError={setError}
                        trigger={trigger}
                        errors={errors}
                        setIsLoading={setIsLoading}
                        imagePopup={imagePopup}
                        mediaImages={mediaImages}
                        startIndex={startIndex}
                        setStartIndex={setStartIndex}
                        setImagePopup={setImagePopup}
                        addPage={addPage}
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item xs={12}> {/* pricing */}
                <Card >
                  <Grid container spacing={2} alignItems="center" sx={{ p: 3 }}>
                    <Grid item xs={12}>
                      <MDTypography variant="h6" className="uppercaseLetters"  >{t('GST')}</MDTypography>

                    </Grid>
                    <Grid item xs={12}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={4} md={4}>
                          <MDTypography variant="body1" className="labelStyle">{t('GSTSlab')}
                            <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                          </MDTypography>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                          <Controller
                            name="gstSlab"
                            control={control}
                            defaultValue={0}
                            render={({ field }) => (
                              <MDInput
                                select
                                {...field}
                                fullWidth
                                InputProps={{
                                  classes: { root: "select-input-styles select-padding-0" }

                                }}

                              >

                                <MenuItem key={0} value={0}>
                                  {'0%'}
                                </MenuItem>
                                <MenuItem key={5} value={5}>
                                  {'5%'}
                                </MenuItem>
                                <MenuItem key={12} value={12}>
                                  {'12%'}
                                </MenuItem>
                                <MenuItem key={18} value={18}>
                                  {'18%'}
                                </MenuItem>
                                <MenuItem key={28} value={28}>
                                  {'28%'}
                                </MenuItem>


                              </MDInput>
                            )}
                          />
                          {errors.gstSlab && (
                            <span className="errorMsg FloatRight">{errors.gstSlab.message}</span>
                          )}

                        </Grid>

                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              {(variantsList && variantsList.length > 0) ?
                null :
                <>
                  <Grid item xs={12}> {/* pricing */}
                    <Card >
                      <Grid container spacing={2} alignItems="center" sx={{ p: 3 }}>
                        <Grid item xs={12}>
                          <MDTypography variant="h6" className="uppercaseLetters"  >{t('pricing')}</MDTypography>
                          <MDTypography component="span" variant="body2" >{t('addPricingDetails')}</MDTypography>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={4} md={4}>
                              <MDTypography variant="body1" className="labelStyle">{t('price')}
                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                              </MDTypography>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8}>
                              <MDInput
                                type="text"
                                name="price"
                                InputProps={{
                                  classes: { root: "inputBoxStyle" },
                                  startAdornment: (
                                    <InputAdornment position="start"><span>₹</span></InputAdornment>
                                  ),
                                }}
                                {...register('price', {
                                  required: {
                                    value: true,
                                    message: t('priceRequired'),
                                  },
                                  validate: (value) => {
                                    if (Number(value) === 0) {
                                      return t('invalidInput');
                                    }
                                    return true;
                                  },
                                })}
                                onChange={e => {
                                  e.stopPropagation();
                                  const inputValue = e.target.value.replace(/[^0-9.]/g, "");
                                  setValue("price", inputValue);
                                }}
                                placeholder={t('enterPrice')}
                                fullWidth
                              />
                              {errors.price && <span className="errorMsg FloatRight">{errors.price.message}</span>}

                            </Grid>
                            <Grid item xs={12} sm={4} md={4}>
                              <MDTypography variant="body1" className="labelStyle">{t('comparePrice')}</MDTypography>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8}>
                              <MDInput
                                type="text"
                                name="comparePrice"
                                InputProps={{
                                  classes: { root: "inputBoxStyle" },
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <span>₹</span>
                                    </InputAdornment>
                                  ),
                                }}
                                {...register('comparePrice', {
                                  validate: (value) => {
                                    if (value && Number(value) === 0) {
                                      return t('invalidInput');
                                    }
                                    return true;
                                  },
                                })}
                                onChange={e => {
                                  e.stopPropagation();
                                  const inputValue = e.target.value.replace(/[^0-9.]/g, "");
                                  setValue("comparePrice", inputValue);
                                }}
                                placeholder={t('enterCompareAtPrice')}
                                fullWidth
                              />
                              {errors.comparePrice && (<span className="errorMsg FloatRight">{errors.comparePrice.message}</span>)}
                            </Grid>
                            <Grid item xs={12} lg={6} >
                              <MDInput
                                type="checkbox"
                                name="taxable"
                                variant="standard"
                                InputProps={{
                                  classes: { root: "inputBoxStyle" },
                                }}
                                {...register("taxable", {
                                })}
                                onChange={e => {
                                  e.stopPropagation();
                                }}
                                className="checkboxStyle"
                              />
                              <MDTypography component="span" variant="body1" className="labelStyle checkboxLabel">{t('taxable')}</MDTypography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>
                  <Grid item xs={12}> {/* inventory */}
                    <Card >
                      <Grid container spacing={2} alignItems="center" sx={{ p: 3 }}>
                        <Grid item xs={12}>
                          <MDTypography variant="h6" className="uppercaseLetters" >{t('inventory')}</MDTypography>
                          <MDTypography component="span" variant="body2"  >     {t('addInventoryDetails')}     </MDTypography>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12}>
                              <MDTypography variant="body1" className="labelStyle">{t('sku')}</MDTypography>
                              <MDInput
                                type="text"
                                name="sku"
                                placeholder={t('enterSku')}
                                InputProps={{
                                  classes: { root: "inputBoxStyle" },
                                }}
                                {...register('sku', {
                                  validate: (value) => {
                                    if (value && value.length > 16) {
                                      return t('skuMax16Chars');
                                    }
                                    if (value && value.length < 4) {
                                      return t('skuMin4Chars');
                                    }
                                    return true;
                                  },
                                })}
                                onChange={e => {
                                  e.stopPropagation();
                                  const trimmedValue = e.target.value.replace(/ /g, '').trim(); // Remove space characters
                                  setValue("sku", trimmedValue);
                                }}
                                onBlur={e => {
                                  e.stopPropagation();
                                  handleSkuExist(e.target.value, getValues('variantId') ? getValues('variantId') : 0, setIsLoading, t, navigate);
                                }}
                                fullWidth
                              />
                              {errors.sku && <span className="errorMsg FloatRight">{errors.sku.message}</span>}
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12}>
                              <MDTypography variant="body1" className="labelStyle">{t('barcode')}</MDTypography>
                              <MDInput
                                type="text"
                                name="barcode"
                                placeholder={t('enterBarcode')}
                                InputProps={{
                                  classes: { root: "inputBoxStyle" },
                                }}
                                {...register('barcode', {
                                })}
                                onChange={e => {
                                  e.stopPropagation();
                                }}
                                fullWidth
                              />
                              {errors.barcode && (<span className="errorMsg FloatRight">{errors.barcode.message}</span>)}
                            </Grid>
                          </Grid>
                        </Grid>
                        {watch('type') == PRODUCT.NORMAL ?
                          <Grid item xs={12} md={6} lg={6}>
                            <Grid container spacing={2} alignItems="center">
                              <Grid item xs={12}>
                                <MDTypography variant="body1" className="labelStyle">{t('purchaseQuantity')}</MDTypography>
                                <MDInput
                                  type="number"
                                  name="minPurchaseQuantity"
                                  placeholder={t('minPurchareQuantity')}
                                  defaultValue={1}
                                  InputProps={{
                                    classes: { root: "inputBoxStyle" },
                                    inputProps: { min: 1 },
                                  }}
                                  {...register('minPurchaseQuantity', {
                                    min: {
                                      value: 1,
                                      message: t('invalidInput'),
                                    },
                                  })}
                                  onChange={e => {
                                    e.stopPropagation();
                                  }}
                                  fullWidth
                                />
                                {errors.minPurchaseQuantity && (<span className="errorMsg FloatRight">{errors.minPurchaseQuantity.message}</span>)}
                              </Grid>
                            </Grid>
                          </Grid>
                          : null}
                        <Grid item xs={12} md={6} lg={6}>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12}>
                              <MDTypography variant="body1" className="labelStyle">{t('trackInventory')}</MDTypography>
                              <MDInput
                                select
                                name="trackInventory"
                                InputProps={{
                                  classes: { root: "select-input-styles " },
                                }}
                                value={watch("trackInventory") || 0}
                                onChange={(event) => setValue('trackInventory', event.target.value)}
                                fullWidth
                              >
                                {tracks.map((track) => (
                                  <MenuItem key={track.value} value={track.value}>{track.name}</MenuItem>
                                ))}
                              </MDInput>
                            </Grid>
                          </Grid>
                        </Grid>
                        {watch("trackInventory") ?
                          <>  <Grid item xs={12} md={6} lg={6}>
                            <Grid container spacing={2} alignItems="center">
                              <Grid item xs={12}>
                                <MDTypography variant="body1" className="labelStyle">
                                  {t('quantity')}
                                  <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography></MDTypography>
                                <MDInput
                                  type="text"
                                  name="quantity"
                                  placeholder={t('enterProductQunatity')}
                                  InputProps={{
                                    classes: { root: "inputBoxStyle" },
                                    min: 0
                                  }}
                                  {...register('quantity', {
                                    required: {
                                      value: true,
                                      message: t('quantityRequired'),
                                    },
                                    pattern: {
                                      value: /^[0-9]+$/,
                                      message: t('invalidInput'),
                                    },
                                    validate: (value) => {
                                      const minPurchaseQuantity = parseInt(getValues('minPurchaseQuantity'));
                                      if ( value > 0 && value < minPurchaseQuantity) {
                                        return t('quantityShouldGreaterThanMinPurchaseQuantity');
                                      }
                                      return true;
                                    },
                                  })}
                                  onChange={e => {
                                    e.stopPropagation();
                                  }}
                                  fullWidth
                                />
                                {errors.quantity && (<span className="errorMsg FloatRight">{errors.quantity.message}</span>)}
                              </Grid>
                            </Grid>
                          </Grid>
                            <Grid item xs={12} md={12} lg={12}>
                              <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} >
                                  <MDInput
                                    type="checkbox"
                                    name="inventoryPolicy"
                                    variant="standard"
                                    InputProps={{
                                      classes: { root: "inputBoxStyle" },
                                    }}
                                    {...register("inventoryPolicy", {
                                    })}
                                    onChange={e => {
                                      e.stopPropagation();
                                    }}
                                    className="checkboxStyle"
                                  />
                                  <MDTypography component="span" variant="body1" className="labelStyle checkboxLabel">{t('inventoryPolicy')}</MDTypography>
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                          : null
                        }
                        {watch('type') == PRODUCT.DIGITAL ?
                          <Grid item xs={12}>
                            <Grid container spacing={2} alignItems="center">
                              <Grid item xs={12} >
                                <MDInput
                                  type="checkbox"
                                  name="productMultipleOptions"
                                  variant="standard"
                                  InputProps={{
                                    classes: { root: "inputBoxStyle" },
                                  }}
                                  {...register("productMultipleOptions")}
                                  className="checkboxStyle"
                                  onClick={() => {
                                    setShowDigitalVariant(!showDigitalVariant)
                                  }}
                                />
                                <MDTypography component="span" variant="body1" className="labelStyle checkboxLabel">{t('productMultipleOptions')}</MDTypography>
                              </Grid>
                            </Grid>
                          </Grid>
                          :
                          null
                        }
                      </Grid>
                    </Card>
                  </Grid>
                </>
              }
              
              {(getValues('type') !== PRODUCT.DIGITAL) && <Variant />}

              {(getValues('type') !== PRODUCT.DIGITAL) && !(variantsList && variantsList.length > 0)
                &&
                <Grid item xs={12}>
                  <Card > {/* shipping */}
                    <Grid container spacing={2} alignItems="center" sx={{ p: 3 }}>
                      <Grid item xs={12} container spacing={2}>
                        <Grid item xs={12}>
                          <MDTypography variant="h6" className="uppercaseLetters" >{t('shipping')} </MDTypography>
                          <MDTypography component="span" variant="body2" >{t('addShippingDetailsHere')}</MDTypography>
                        </Grid>
                        <Grid item xs={12} lg={12} >
                          <MDInput
                            type="checkbox"
                            name="requireShipping"
                            variant="standard"
                            disabled
                            InputProps={{
                              classes: { root: "inputBoxStyle" },
                            }}
                            {...register("requireShipping", {
                            })}
                            className="checkboxStyle"
                          />
                          <MDTypography component="span" variant="body1" className="labelStyle checkboxLabel" >{t('requireShipping')}</MDTypography>
                        </Grid>

                        <Grid item xs={12} lg={6} md={6}>
                          <MDTypography variant="body1" className="labelStyle" >{t('weight')}</MDTypography>
                          <Grid item xs={12} lg={12}>
                            <MDInput
                              type="text"
                              name="weight"
                              placeholder={t('enterWeight')}
                              InputProps={{
                                classes: { root: "inputBoxStyle" },
                              }}
                              {...register("weight", {
                                validate: (value) => {
                                  if (value && Number(value) === 0) {
                                    return t('invalidInput');
                                  }
                                  return true;
                                },
                              })}
                              onChange={((e) => {
                                e.stopPropagation();
                                const inputValue = e.target.value.replace(/[^0-9.]/g, "");
                                setValue("weight", inputValue);
                              })}
                              fullWidth
                            />
                            {errors.weight && (<span className="errorMsg FloatRight">{errors.weight.message}</span>)}
                          </Grid>
                        </Grid>
                        <Grid item xs={12} lg={6} md={6}>
                          <MDTypography variant="body1" className="labelStyle" >{t('weightUnit')}</MDTypography>
                          <Grid item xs={12} lg={12}>
                            <Controller
                              name="weightUnit"
                              control={control}
                              defaultValue={(responseData && responseData.variants && responseData.variants.weightUnit) ? responseData.variants.weightUnit : "kg" || "kg"}
                              render={({ field }) => (
                                <MDInput
                                  select
                                  {...field}
                                  fullWidth
                                  InputProps={{
                                    classes: { root: "select-input-styles " },
                                  }}
                                >
                                  {units.map((unit) => (
                                    <MenuItem key={unit.value} value={unit.value}>{unit.name}</MenuItem>
                                  ))}
                                </MDInput>
                              )}
                            />
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <MDTypography variant="h6">{t('dimensions')}</MDTypography>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                          <MDTypography variant="body1" className="labelStyle">{t('width')}
                            <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                          </MDTypography>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                          <MDInput
                            type="text"
                            name="width"
                            defaultValue=""
                            placeholder={t('minimumWidth')}
                            InputProps={{
                              classes: { root: "inputBoxStyle" },
                            }}
                            {...register("width", {
                              required: {
                                value: true,
                                message: t('widthRequired')
                              },
                              validate: (value) => {
                                if (Number(value) === 0) {
                                  return t('invalidInput');
                                }
                                return true;
                              },
                            })}
                            onChange={((e) => {
                              e.stopPropagation();
                              const inputValue = e.target.value.replace(/[^0-9.]/g, "");
                              setValue("width", inputValue);
                              setVolumetricWidth(inputValue)
                            })}
                            fullWidth />
                          {errors.width && (<span className="errorMsg FloatRight">{errors.width.message}</span>)}
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                          <MDTypography variant="body1" className="labelStyle">{t('dHeight')}
                            <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                          </MDTypography>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                          <MDInput
                            type="text"
                            name="dHeight"
                            defaultValue=""
                            placeholder={t('minimumHeight')}
                            InputProps={{
                              classes: { root: "inputBoxStyle" },
                            }}
                            {...register("dHeight", {
                              required: {
                                value: true,
                                message: t('dHeightRequired')
                              },
                              validate: (value) => {
                                if (Number(value) === 0) {
                                  return t('invalidInput');
                                }
                                return true;
                              },
                            })}
                            onChange={((e) => {
                              e.stopPropagation();
                              const inputValue = e.target.value.replace(/[^0-9.]/g, "");
                              setValue("dHeight", inputValue);
                              setVolumetricHeight(inputValue);
                            })}
                            fullWidth />
                          {errors.dHeight && (<span className="errorMsg FloatRight">{errors.dHeight.message}</span>)}
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                          <MDTypography variant="body1" className="labelStyle">{t('length')}
                            <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                          </MDTypography>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                          <MDInput
                            type="text"
                            name="length"
                            defaultValue=""
                            placeholder={t('minimumLength')}
                            InputProps={{
                              classes: { root: "inputBoxStyle" },
                            }}
                            {...register("length", {
                              required: {
                                value: true,
                                message: t('lengthRequired')
                              },
                              validate: (value) => {
                                if (Number(value) === 0) {
                                  return t('invalidInput');
                                }
                                return true;
                              },
                            })}
                            onChange={((e) => {
                              e.stopPropagation();
                              const inputValue = e.target.value.replace(/[^0-9.]/g, "");
                              setValue("length", inputValue);
                              setVolumetricLength(inputValue);
                            })}
                            fullWidth />
                          {errors.length && (<span className="errorMsg FloatRight">{errors.length.message}</span>)}
                        </Grid>

                        {volumetricWeight && (
                          <>
                            <Grid item xs={12} sm={4} md={4}>

                              <MDTypography variant="body1" className="labelStyle">{t('calculatedVolumetricWeight')}

                              </MDTypography>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8}>
                              {volumetricWeight}
                            </Grid>
                          </>
                        )}

                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              }

              {(getValues('type') == PRODUCT.DIGITAL && showDigitalVariant) && <Variant />
              }

              {(getValues('type') == PRODUCT.DIGITAL && !showDigitalVariant)
                &&
                <Grid item xs={12}>
                  <Card >
                    <Grid container spacing={2} alignItems="center" sx={{ p: 3 }}>
                      <Grid item xs={12} container spacing={2}>
                        <Grid item xs={12}>
                          <MDTypography variant="h6" className="uppercaseLetters">{t('digitalProductDetails')}</MDTypography>
                          <MDTypography component="span" variant="body2"  >{t('detaileddigitalProduct')}</MDTypography>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                          <MDTypography variant="body1" className="labelStyle">{t('addDigitalProductAs')}</MDTypography>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                          <Controller
                            name="digitalType"
                            control={control}
                            rules={{
                            }}
                            defaultValue={digitalProductInfo.type || "file"}
                            render={({ field }) => (
                              <MDInput
                                select
                                {...field}
                                fullWidth
                                InputProps={{
                                  classes: { root: "select-input-styles " },
                                }}
                              >
                                {digitalType.map((type) => (
                                  <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
                                ))}
                              </MDInput>
                            )}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <MDTypography variant="h7">{t('addDigitalProduct')}</MDTypography>
                        </Grid>
                        {(watch('digitalType') == 'file') ?
                          <>
                            <Grid item xs={12} sm={4} md={4}>
                              <MDTypography variant="body1" className="labelStyle">{t('uploadFile')}
                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                              </MDTypography>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8}>
                              <MDInput
                                type="file"
                                name="digitalFile"
                                InputProps={{
                                  classes: { root: "inputBoxStyle" },
                                }}
                                {...register('digitalFile', {
                                  required: {
                                    value: (digitalFileInfo && digitalFileInfo[0]) ? false : true,
                                    message: t('digitalFileRequired')
                                  }
                                })}
                                onChange={((e) => {
                                  e.stopPropagation()
                                  const file = e.target.files[0];
                                  if (file) {
                                    handleDigitalFileUpload(e);
                                  }
                                })}
                                fullWidth />
                              {digitalFileUploadLoading ? <CircularProgress color="inherit" size={"20px"} /> : null}
                              {errors.digitalFile && (<span className="errorMsg FloatRight">{errors.digitalFile.message}</span>)}
                              {digitalFileInfo && (
                                <MDTypography component="span" variant="body2" color="inherit">
                                  {digitalFileInfo ? digitalFileInfo[0] ? digitalFileInfo[0] : "" : ""}
                                </MDTypography>)}
                            </Grid>
                          </>
                          :
                          <>
                            <Grid item xs={12} sm={4} md={4}>
                              <MDTypography variant="body1" className="labelStyle">{t('digitalProductFileLink')}
                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                              </MDTypography>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8}>
                              <MDInput
                                type="text"
                                name="digitalProductFileLink"
                                defaultValue={digitalProductInfo.fileUrl || ''}
                                InputProps={{
                                  classes: { root: "inputBoxStyle" },
                                  inputProps: { min: 0 },
                                }}
                                {...register('digitalProductFileLink', {
                                  required: {
                                    value: true,
                                    message: t('digitalProductFileLinkRequired')
                                  },
                                  validate: (value) => {
                                    if (!isURL(value)) {
                                      return t('invalidUrl');
                                    }
                                    return true;
                                  },


                                })}
                                fullWidth />
                              {errors.digitalProductFileLink && (<span className="errorMsg FloatRight">{errors.digitalProductFileLink.message}</span>)}
                            </Grid>
                          </>
                        }
                        <Grid item xs={12} sm={4} md={4}>
                          <MDTypography variant="body1" className="labelStyle">{t('numberOfAccessibleDays')}
                            <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                          </MDTypography>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                          <MDInput
                            type="number"
                            name="numberOfAccessibleDays"
                            defaultValue={digitalProductInfo.noOfAccessDays || 0}
                            InputProps={{
                              classes: { root: "inputBoxStyle" },
                              inputProps: { min: 0 },
                            }}
                            {...register('numberOfAccessibleDays', {
                              required: {
                                value: true,
                                message: t('numberOfAccessibleDaysRequired')
                              }
                            })}
                            fullWidth />
                          {errors.numberOfAccessibleDays && (
                            <span className="errorMsg FloatRight">{errors.numberOfAccessibleDays.message}</span>
                          )}
                          <MDTypography component="span" variant="body2" color="error" className="EditProductSpanText">{t('noteForAccessibleDays')}</MDTypography>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                          <MDTypography variant="body1" className="labelStyle">{t('numberOfDownloads')}
                            <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                          </MDTypography>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                          <MDInput
                            type="number"
                            name="numberOfDownloads"
                            defaultValue={digitalProductInfo.noOfDownloads || 0}
                            InputProps={{
                              classes: { root: "inputBoxStyle" },
                              inputProps: { min: 0 },
                            }}
                            {...register('numberOfDownloads', {
                              required: {
                                value: true,
                                message: t('numberOfDownloadsRequired')
                              }

                            })}
                            fullWidth />
                          {errors.numberOfDownloads && (<span className="errorMsg FloatRight">{errors.numberOfDownloads.message}</span>)}
                          <MDTypography component="span" variant="body2" color="error" className="EditProductSpanText">{t('downloadDetails')}</MDTypography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              }

              {/* country of origin */}
              {(variantsList && variantsList.length > 0) ?
                null :
                <Grid item xs={12} md={12} lg={12}>
                  <CountryOfOrigin
                    dataFrom="product"
                    register={register}
                    errors={errors}
                    setError={setError}
                    selectedCountryOfOrgin={selectedCountryOfOrgin}
                    setSelectedCountryOfOrgin={setSelectedCountryOfOrgin}
                    isDropdownOpen={isDropdownOpen}
                    setIsDropdownOpen={setIsDropdownOpen}
                  />
                </Grid>
              }

              <Grid item xs={12}>{/*custom fields*/}
                <CustomFields
                  dataFrom="product"
                  customFields={customFields}
                  control={control}
                  errors={errors}
                  categoryCustomFields={categoryCustomFields}
                  categories={categories}
                  selectedCustomMultiselect={selectedCustomMultiselect}
                  setSelectedCustomMultiselect={setSelectedCustomMultiselect}
                  register={register}
                  setValue={setValue}
                  setError={setError}
                  productId={product_Id}
                  setCategoryCustomFields={setCategoryCustomFields}
                  setCustomFields={setCustomFields}
                  setIsLoading={setIsLoading}
                />
              </Grid>

              <Grid item xs={12}>
                <Grid item className="productSubmit">
                  {((product_Id && watch('productStatus') == 0) || addPage) ?
                    <MDBox mt={4} mb={4}>
                      <MDButton type="button" variant="gradient" color="info" onClick={() => handleButtonClick(false)} disableRipple>{t('draft')}</MDButton>
                    </MDBox>
                    : null
                  }
                  <MDBox ml={1} mt={4} mb={4}>
                    <MDButton type="submit" variant="gradient" color="info" onClick={() => handleButtonClick(true)} disableRipple>{t('submit')}</MDButton>
                  </MDBox>
                </Grid>
              </Grid>

            </Grid>
          </MDBox>
        </Grid>


      </MDBox>



      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Product;
